import { theme } from '../../Assets/Styles/theme'

export const styles = {
  container: {
    height: 40,
    display: 'flex',
    flexDirection: 'row',
  },
  tab: {
    padding: '6px 18px',
    fontSize: 16,
    color: '#011533',
    fontWeight: '400',
    fontFamily: "'Proxima Nova', sans-serif",
    borderBottom: '1px solid #AEAFC7',
    '&:hover': {
      cursor: 'pointer',
    },
  },
  tabActive: {
    borderBottom: `2px solid ${theme.colors.primary}`,
    fontWeight: '700',
    color: '#011533',
    transition: 'all .3s',
  },

  barge: {
    height: 6,
    width: 6,
    marginLeft: 10,
    display: 'flex',
    justifyContent: 'center',
    backgroundColor: theme.colors.primary,
    borderRadius: 10,
    color: 'white',
    fontSize: 12,
    fontFamily: "'Proxima Nova', sans-serif",
  },
  bargeActive: {
    fontWeight: '400',
  },
  item: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
}
